{
  "hero": {
    "eyebrow": "团队",
    "title": "四支学生子团队，一个监测平台。",
    "lead": "AquaWorks 在项目领导下按软件、电气、机械与商务四队组织——共同建造、记录并传播可复用的校园水质机器人。"
  },
  "leadership": {
    "title": "项目领导",
    "lead": "确定范围、顾问对接、文档标准与里程碑。"
  },
  "coordinator": {
    "title": "协调",
    "lead": "通过协调与沟通，让四支团队保持对齐。"
  },
  "domains": {
    "title": "四支团队",
    "lead": "各流拥有清晰交付物，并共享同一集成时间线。",
    "items": {
      "software": { "title": "软件团队", "body": "嵌入式控制、数据记录、无线通信、清洗流程与可视化。" },
      "electrical": { "title": "电气团队", "body": "电源分配、微控制器集成、电机控制、传感器接口、电量监测与电气安全。" },
      "mechanical": { "title": "机械团队", "body": "浮体平台、浮力、防水、推进与传感器安装、CAD 与回收结构。" },
      "business": { "title": "商务团队", "body": "预算、采购、报销跟踪、利益相关方更新、策略与项目档案组织。" }
    }
  },
  "groups": {
    "title": "组长与成员",
    "lead": "各组负责人从该组成员名单中单独列出。对外公开邮箱仅限项目负责人。",
    "leadLabel": "组长",
    "membersLabel": "成员",
    "empty": "名册上暂无其他成员。"
  },
  "members": {
    "jiaming": { "role": "项目负责人", "program": "应用科学学院", "focus": "范围、可持续叙事、报告", "statement": "希望 AquaWorks 让环境数据真正服务学生学习与校园可持续讨论。" },
    "lucas": { "role": "联合项目负责人", "program": "应用科学学院", "focus": "平台方向、文档", "statement": "审慎的原型应留给下一届可信的决策、数据与边界。" },
    "fengwe": { "role": "协调人", "program": "应用科学学院 · 大四", "focus": "跨组协调与沟通", "statement": "各队看见同一套决策、边界与下一步，建造才会保持一致。" },
    "younger": { "role": "软件组员", "program": "应用科学学院", "focus": "软件", "statement": "软件应当清楚到下一届还能接着往下做。" },
    "daniel": { "role": "软件组员", "program": "应用科学学院", "focus": "控制逻辑、记录、可视化", "statement": "平台上的代码应让一次读数可追溯，而不只是显示出来。" },
    "yuzhe": { "role": "电气负责人", "program": "应用科学学院 · 大四", "focus": "传感器、电路、固件", "statement": "传感器、电路与固件应当做得让下一个人能看清一次读数为什么是对的。" },
    "zongyu": { "role": "电路设计与集成", "program": "应用科学学院 · 大四", "focus": "电子架构、传感器集成", "statement": "可靠读数始于严谨的硬件集成。" },
    "xuan": { "role": "电路设计与集成", "program": "应用科学学院 · 大四", "focus": "布线、连接器、系统稳定性", "statement": "野外平台需要清晰的电气决策与文档。" },
    "harris": { "role": "电路设计与集成", "program": "应用科学学院 · 大四", "focus": "电源、驱动、台架验证", "statement": "电子系统应能在近水环境中工作并保持可追溯。" },
    "crown": { "role": "机械设计负责人", "program": "应用科学学院 · 大四", "focus": "船体、模块结构、物理集成", "statement": "平台必须可维修、可理解，而不只是一次性能用。" },
    "tianyu": { "role": "机械装配与集成", "program": "应用科学学院 · 大四", "focus": "制造、测试支持、现场就绪", "statement": "最好的原型是下一届可以检查并改进的原型。" },
    "haoxuan": { "role": "机械装配与集成", "program": "应用科学学院 · 大四", "focus": "装配、验证、维修流程", "statement": "物理设计应支持维护，而不是隐藏问题。" },
    "minal": { "role": "研究与采购协调", "program": "应用科学学院 · 大二", "focus": "寻源、比价、采购记录", "statement": "良好采购让建造保持模块化、有文档、且对下一届可负担。" },
    "jane": { "role": "商务拓展与策略", "program": "Sauder 商学院 · 大三", "focus": "合作、叙事、可持续框架", "statement": "清晰叙事帮助校园各方理解学生监测能与不能宣称什么。" },
    "alice": { "role": "商务负责人", "program": "Sauder 商学院 · 大三", "focus": "利益相关方更新、外联材料", "statement": "沟通应诚实面对不确定性与测试边界。" },
    "max": { "role": "商务拓展与策略", "program": "Sauder 商学院 · 大二", "focus": "运营支持、档案就绪", "statement": "运营把愿景变成进度、预算与可延续的交接包。" }
  },
  "note": {
    "body": "我们已咨询的顾问与校园伙伴包括 Campus and Community Planning 与土木工程相关教师。合作随许可、安全审查与共同目标增长。"
  }
}
